<template>
<div class="chapter">
<div class="inner_page">
<div style="padding-top:220px;">
<p style="text-align:Center;"><span dir="rtl">أريد حُضْنك</span></p>
<p style="text-align:Center;"><span dir="rtl">وطنًا</span></p>
<p style="text-align:Center;"><span dir="rtl">فأنا مهاجِرٌ أرهَقَه</span></p>
<p style="text-align:Center;"><span dir="rtl">الشَّتاتُ</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?7b42bc39